<app-toasts/>
@if (loaderS.loading) {
  <app-preloader/>
}
<div class="flex h-full flex-col [&_main]:mt-2.5 [&_main]:flex-1 [&_main]:pb-[30px]">
  <app-header/>
  <main>
    <app-container>
      <router-outlet/>
    </app-container>
  </main>
  <app-footer/>
</div>

<button class="invisible fixed bottom-6 right-6 z-[60] size-11 translate-y-3 cursor-pointer rounded-full border-0 bg-[var(--primary-color)] text-xl leading-none text-white opacity-0 shadow-[0_4px_14px_rgba(0,0,0,0.25)] transition-[opacity,transform,visibility] duration-300 hover:bg-[var(--primary-color-lighter)] [&.show]:visible [&.show]:translate-y-0 [&.show]:opacity-100" type="button"
        [class.show]="scrolled()"
        (click)="scrollTop()"
        title="Наверх"
        aria-label="Прокрутить страницу наверх">↑</button>
